import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import HomeIcon from "@mui/icons-material/Home";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import DescriptionIcon from "@mui/icons-material/Description";
import PersonIcon from "@mui/icons-material/Person";

import CustomForm from "../../../helper-components/form/CustomForm";
import NavigationFooter from "../../../helper-components/misc/NavigationFooter";

import UsersTable from "./components/UsersTable";

import { getLanguage } from "../../../config/language/language.js";

/**
 * The users page.
 */
export default function Users(props) {
    return (
        <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <CustomForm title={getLanguage().USERS_TITLE} subtitle={getLanguage().USERS_SUBTITLE} icon={<PersonIcon />} />
                </Grid>

                <Grid item xs={12}>
                    <UsersTable {...props} />
                </Grid>

                <NavigationFooter
                    rows={2}
                    options={[
                        {
                            path: `/database/entities`,
                            title: "Entities",
                            variant: "outlined",
                            icon: <TextFieldsIcon />
                        },
                        {
                            path: `/database/resources`,
                            title: "Resources",
                            variant: "outlined",
                            icon: <DescriptionIcon />
                        },
                        {
                            path: `/home`,
                            title: "Home",
                            variant: "outlined",
                            icon: <HomeIcon />
                        }
                    ]}
                />
            </Grid>
        </Container>
    );
}
